import { z } from "zod";

export const schema = z.object({
    title: z.string().min(1, "forms.general-validation.title_required"),
    advertiser: z.string().min(1, "forms.general-validation.advertiser_required"),
    currency_id: z.number(),
});

export type AddOfferFormData = z.infer<typeof schema>;
